<template>
  <div id="contact">
    <v-container>
      <v-row justify="center" class="mt-5">
        <v-col md="6">
          <div class="pa-5 pa-md-0">
            <h1 class="tw-text-2xl tw-font-bold tw-mb-5">ติดต่อภาษีเจริญ</h1>
            <p>ชั้น 6 อาคาร Q House เพลินจิต 598 ถนนเพลินจิต แขวงลุมพินี<br /> เขตปทุมวัน กรุงเทพฯ 10330</p>
            <div class="tw-mb-4 tw-flex">
              <img src="/images/icons/phone.svg" class="tw-mr-5">
              <a href="tel:0 2663 7895" style="color: #000000">02 663 7895</a>
            </div>
            <div class="tw-flex">
              <img src="/images/icons/email.svg" class="tw-mr-5">
              <a href="mailto:hello@phasicharoen.com" style="color: #000000">hello@phasicharoen.com</a>
            </div>
          </div>
        </v-col>
        <v-col md="6">
          <div class="form" style="margin: 0; padding: 0 20px;">
            <form @submit="customerSendEmail">
              <input type="text" placeholder="ชื่อ" v-model="name" required>
              <input type="email" placeholder="อีเมล" v-model="email" required>
              <input type="tel" placeholder="เบอร์โทรศัพท์" v-model="phone" required>
              <textarea type="text" placeholder="รายละเอียด" v-model="description" required></textarea>
              <button v-if="!sending">ติดต่อเรา</button>
              <v-alert
                dense
                border="left"
                type="warning"
                class="mt-2"
                style="width: 80%; margin: 0 auto;"
                v-if="sending">
                กำลังส่ง
              </v-alert>
            </form>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style lang="scss">
#contact {
  h1 {

  }

  .form {
    padding: 20px 40px 0;
    text-align: center;

    input, textarea {
      width: 100%;
      height: 44px;
      border-radius: 10px;
      border: solid 1px #c4c4c4;
      background-color: #ffffff;
      padding: 20px;
      display: block;
      margin-top: 10px;
    }

    textarea {
      height: 100px;
    }

    button {
      width: 300px;
      height: 44px;
      border-radius: 10px;
      background-color: #6ec39b;
      color: #FFFFFF;
      margin-top: 10px;
    }
  }
}
</style>

<script>

const axios = require("axios");
import fc from '@/firebaseConfig'

export default {
  data: function () {
    return {
      name: "",
      email: "",
      phone: "",
      description: "",
      sending: false
    }
  },
  methods: {
    customerSendEmail: async function (e) {
      e.preventDefault();
      this.sending = true;
      let data = {
        'name': this.name,
        'email': this.email,
        'phone': this.phone,
        'description': this.description,
      }
      await axios.post(fc.cloudFunctionUrl + "customerSendEmail", data)
        .then((response) => {
          if (response.status === 200) {
            alert('ทางเราได้รับข้อความจากท่านแล้ว พนักงานจะรีบติดต่อท่านวันทำการ')
            this.sending = false;
          }
        }, () => {
          this.sending = false;
        });
    }
  }
}

</script>
